





















































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import BaseServiceMixin from "../mixins/base.service.mixin";
import ZenDeskTicketModel, { UpdateZenDeskTicketModel } from "../models/ZenDeskTicketModel";
import TicketService from "@/services/ticket.service";
import Shared from "../common/shared";
import { Priority, TicketType, TicketStatus } from "@/common/enum";
import CompanyService from "../services/company.service";
import { CompanyModel } from "../models/CompanyModel";
import { RequesterModel } from "../models/RequesterModel";
import ZenDeskTicketCommentModel from "../models/ZenDeskTicketCommentModel";
import Filters from "@/common/Filters";
import { ValidationObserver } from "vee-validate";
import vueCustomScrollbar from "vue-custom-scrollbar";
import SignalRService from "../services/signalr.service";
import { UserModel } from "../models/UserModel";

@Component({
  components: {
    ValidationObserver,
    vueCustomScrollbar,
  },
  filters: {
    difference: Filters.difference,
  },
})
export default class Ticket extends Mixins(BaseServiceMixin) {
  private ticketService!: TicketService;
  private signalRService!: SignalRService;
  private master: ZenDeskTicketModel = new ZenDeskTicketModel();
  private ticket: ZenDeskTicketModel = new ZenDeskTicketModel();
  private loading = false;
  private componentLoad = false;
  private getStatusColor = Shared.getStatusColor;
  private priority = Priority;
  private ticketType = TicketType;
  private ticketStatus = TicketStatus;
  private companyService!: CompanyService;
  private companies: CompanyModel[] = [];
  private company: CompanyModel | null = null;
  private requesters: UserModel[] = [];
  private requester: UserModel | null = null;
  private editCompany = false;
  private companyLoading = false;
  private comment: ZenDeskTicketCommentModel = new ZenDeskTicketCommentModel();
  private commentTab = 0;
  private assignees: RequesterModel[] = [];
  private isTicketUpdate = false;

  private get ticketId(): number {
    return Number(this.$route.params.id) || 0;
  }

  private get isEdit(): boolean {
    return this.master.id ? true : false;
  }

  private get isZing(): boolean {
    return this.vuexStore.user ? this.vuexStore.user.isZing : false;
  }

  private get isClosed(): boolean {
    return this.master.status === TicketStatus.Closed;
  }

  private get assignee(): string {
    const assignee: RequesterModel | undefined = this.assignees.find(
      (assignee: RequesterModel) => assignee.id === this.ticket.assigneeId,
    );
    return assignee ? assignee.name : "-";
  }

  private get isAllowedCompanyChange(): boolean {
    if (!this.isZing) {
      return false;
    }
    if (this.isEdit) {
      return this.editCompany;
    }
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private get ticketForm(): any {
    return this.$refs.ticketForm;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private get companyForm(): any {
    return this.$refs.companyForm;
  }

  private get ticketComments(): ZenDeskTicketCommentModel[] {
    return this.ticket.comments || [];
  }

  public async created() {
    this.ticketService = new TicketService(this.axiosInstance);
    this.companyService = new CompanyService(this.axiosInstance);
    this.signalRService = new SignalRService(this.axiosInstance, "zendeskTickets");
    this.signalRService.addHandler("ticket-message", this.onUpdateTicket);
  }

  public async mounted() {
    this.componentLoad = true;

    this.ticket.status = TicketStatus.Open;
    await this.getCompanies();

    if (this.isZing) {
      await this.getAssignees();
    }

    if (this.ticketId > 0) {
      await this.getTicket();
    }
    if (this.ticketId <= 0 && this.$router.currentRoute.name === "View-Ticket") {
      this.goBack();
      return;
    }

    if (!this.isEdit) {
      this.ticket.status = TicketStatus.Open;
    }

    try {
      await this.signalRService.connectHub();
    } catch (e) {
      // handle error
    }

    this.componentLoad = false;
  }

  @Watch("master", { deep: true })
  private updateInternal() {
    this.ticket = Object.assign(new ZenDeskTicketModel(), this.master);
  }

  private async getTicket() {
    try {
      this.loading = true;
      this.master = await this.ticketService.getTicket(this.ticketId);
      if (!this.isZing && this.vuexStore.company && this.master.companyId !== this.vuexStore.company.id) {
        this.loading = false;
        Shared.showToastMessage(Shared.messages.TICKET_ACCESS_DENIED, "is-danger");
        this.$router.push({ name: "403" });
      }
      await this.setCompany();
    } catch (error) {
      if (error.name === Shared.notFound) {
        this.loading = false;
        Shared.showToastMessage(error.message, "is-danger");
        this.$router.push({ name: "404" });
      }
    } finally {
      this.loading = false;
    }
  }

  private async setCompany() {
    const company = this.companies.find((company: CompanyModel) => company.id === this.master.companyId);
    if (company) {
      this.company = company;
    } else {
      this.company = null;
    }
  }

  @Watch("company", { deep: true })
  private async getRequesters() {
    this.companyLoading = true;
    try {
      if (this.company) {
        this.ticket.companyId = this.company.id;
        this.requesters = await this.ticketService.getRequesterByCompany(this.company.id);
        this.setRequester();
      }
    } catch (error) {
      // Handle Error
    } finally {
      this.companyLoading = false;
    }
  }

  private async setRequester() {
    const requester = this.requesters.find(
      (requester: UserModel) => requester.zendeskUserId === this.master.requesterId,
    );
    if (requester) {
      this.requester = requester;
    } else {
      this.requester = null;
    }
  }

  @Watch("requester", { deep: true })
  private async updateTicketRequester() {
    if (this.requester) {
      this.ticket.requesterId = this.requester.zendeskUserId;
      this.ticket.requesterName = this.requester.fullName;
      this.ticket.requesterEmail = this.requester.email;
    }
  }

  private async getCompanies() {
    try {
      this.companies = await this.companyService.getCompanyList();
    } catch (error) {
      // Handle Error
    }
  }

  private async getAssignees() {
    try {
      this.assignees = await this.ticketService.getAssignees();
    } catch (error) {
      // Handle Error
    }
  }

  private subjectChange() {
    if (!this.ticket.subject || this.ticket.subject === "") {
      this.ticket.subject = this.master.subject;
    }
  }

  private async changeAndSubmit(status: TicketStatus) {
    this.ticket.status = status;
    await this.saveTicket();
  }

  private async saveTicket() {
    if (this.master.status === TicketStatus.Closed) {
      return;
    }

    let validate = false;

    if (this.companyForm) {
      validate = (await this.companyForm.validate()) && (await this.ticketForm.validate());
    } else {
      validate = await this.ticketForm.validate();
    }

    if (!validate) {
      this.ticket.status = this.master.status;
      return;
    }

    this.loading = true;

    if (this.isEdit) {
      this.comment.isPublic = true;
      if (this.commentTab === 1) {
        this.comment.isPublic = false;
      }

      const ticket: UpdateZenDeskTicketModel = Object.assign(new UpdateZenDeskTicketModel(), {
        ...this.ticket,
        comment: this.comment,
      });
      delete ticket.comments;

      try {
        await this.ticketService.updateTicket(ticket);
        Shared.showToastMessage(Shared.messages.TICKET_UPDATED, "is-success");
        this.goBack();
      } catch (error) {
        // Handle error
      } finally {
        this.loading = false;
      }
    } else {
      try {
        const ticket: ZenDeskTicketModel = await this.ticketService.createTicket(this.ticket);
        Shared.showToastMessage(Shared.messages.TICKET_CREATED, "is-success");
        this.$router.push({ name: "View-Ticket", params: { id: ticket.id.toString() } });
      } catch (error) {
        // Handle error
      } finally {
        this.loading = false;
      }
    }
  }

  private async saveCompany() {
    const validateCompany = await this.companyForm.validate();

    if (!validateCompany) {
      return;
    }
    this.companyLoading = true;
    try {
      await this.ticketService.updateTicketCompany(this.ticket);
      this.editCompany = false;
      await this.getTicket();
    } catch (error) {
      // Handle Error
    } finally {
      this.companyLoading = false;
    }
  }

  private goBack() {
    this.$router.push({ name: "Tickets" });
  }

  private onCancelCompany() {
    this.setCompany();
    this.setRequester();
    this.editCompany = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private onUpdateTicket(data: any) {
    const updatedTicket: ZenDeskTicketModel = data.Ticket;
    if (this.ticketId == updatedTicket.id) {
      setTimeout(() => {
        this.isTicketUpdate = true;
      }, 3000);
    }
  }

  private async onRefresh() {
    this.isTicketUpdate = false;
    await this.getTicket();
  }

  private async destroyed() {
    try {
      await this.signalRService.disconnectHub();
    } catch (err) {
      // handle error
    }
  }
}
